import React from 'react';

const MusicIcon = ({ size = 20, color = "#55000C", strokeWidth = 1.25, className = "", ...props }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 20 20" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path 
      d="M10.832 14.9993V1.66602" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round"
    />
    <path 
      d="M7.49935 18.3327C9.3403 18.3327 10.8327 16.8403 10.8327 14.9993C10.8327 13.1584 9.3403 11.666 7.49935 11.666C5.6584 11.666 4.16602 13.1584 4.16602 14.9993C4.16602 16.8403 5.6584 18.3327 7.49935 18.3327Z" 
      stroke={color} 
      strokeWidth={strokeWidth}
    />
    <path 
      d="M15.832 6.66602C14.5059 6.66602 13.2342 6.13923 12.2965 5.20155C11.3588 4.26387 10.832 2.9921 10.832 1.66602" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round"
    />
  </svg>
);

export default MusicIcon;